import React from 'react'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import { StyleSheet } from 'react-native'
import _ from "lodash"
import { GraphBookedDays, GraphBookingPresenceChart, GraphBookingPresenceDayChart, GraphBookingPresenceWeekChart, GraphCheckinTime, GraphEmployeeBookingsWeek, GraphTotalBookingsWeek } from 'components/management/molecules/graphs'
import GraphDateRange from 'components/atoms/GraphDateRange'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const ViewOffice = ({ dateRange }) => {
	
	const graphs = [
		<GraphCheckinTime
			dateRange={ dateRange }
		/>,
		<GraphBookedDays
			dateRange={ dateRange }
		/>,
		<GraphTotalBookingsWeek
			dateRange={ dateRange }
		/>,
		<GraphEmployeeBookingsWeek
			dateRange={ dateRange }
		/>,
		<GraphBookingPresenceChart
			dateRange={ dateRange }
		/>,
		<GraphBookingPresenceWeekChart
			dateRange={ dateRange }
		/>,
		<GraphBookingPresenceDayChart
			dateRange={ dateRange }
		/>,
	]
	
	return (
		<Grid>
			<Container>
				<Row>
					<Column>
						<GraphDateRange containerStyle={ styles.graphDateRangeMarginTop0} />
					</Column>
				</Row>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					{ _.map( graphs, graph => {
						return (
							<Row style={ styles.chart }>
								<Column
									span={ 12 }>

									{ graph }
								</Column>
							</Row>
						);
					})}
				</VStack>
			</Container>
		</Grid>
	)
}

const styles = StyleSheet.create({
	graphDateRangeMarginTop0: {
		marginTop: 0,
	},
	chart: {
		marginBottom: 10
	}
});

export default ViewOffice
